import React, { Component } from 'react';
import FormExtractions from './components/FormExtractions';
import swal from 'sweetalert';
import 'sweetalert/dist/sweetalert.css';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import WaitingModal from '../generics/WaitingModal';
import Notifications, {notify} from 'react-notify-toast';
import moment from 'moment';

var Config = require('../../config');

const style = {
  margin: 12,
};

class ExtractionsNew extends Component{
	constructor(props) {
	    super(props);
	    this.saveItem = this.saveItem.bind(this);
	    this.cancel = this.cancel.bind(this);
		this.onSave = this.onSave.bind(this);
		this.saveExtraction = this.saveExtraction.bind(this);

		this.state = {
			disable_on_save:false
		}
	}

	componentDidMount(){
	}

	cancel(e){
		//this.props.history.push("/offers");
		this.props.history.goBack();
	}

	//Funcion Submit Form
	saveItem(e){
		this.setState({disable_on_save: true});
		e.preventDefault();

		setTimeout(()=>{
			var val1 = parseInt(this.form.state.proc_ext_ce.value);
			var val2 = parseInt(this.form.state.proc_ext_plasma.value);
			var val3 = parseInt(this.form.state.proc_ext_plaq.value);
			
			var min = Math.min(val1, val2, val3);

			
			if(this.form.state.extraction_time !== "" && this.form.state.offer.type_extraction_name !== "AFÉRESIS"){
				var time = parseInt(this.form.state.extraction_time)

				if(time > min){
					var dif = time - min;
					swal({
						title:'Alerta',
						text:'Esta extracción se excede por '+dif+' minutos de tiempo de extracción '+
							'lo cual puede provocar que esta unidad no pueda ser fraccionada.'+
							' Desea Continuar?',
						showCancelButton: true,
				        confirmButtonColor: '#DD6B55',
				        confirmButtonText: '¡Si, Continuar!',
				        cancelButtonText: '¡No, Cancelar!',
				        closeOnConfirm: true,
				        closeOnCancel: true,
					}, (isConfirm)=>{
						this.onSave();
					})
				}else{
					this.onSave();
				}
			}else{
				this.onSave();
			}

		}, 500);


			
	}

	onSave(){
		if(this.form.state.donation_number === ""){
			this.setState({disable_on_save: false});
			swal('Error', '¡No se ha generado el número de donación!', 'error');
			
		}else if(!this.form.state.valid_days){
			if(this.form.state.days_after_register > parseInt(this.form.state.don_days_offer.value)){
				var msg = '¡El numero de dias permitidos despues del registro es de '+
						this.form.state.don_days_offer.value+' dias, el registro se realizó hace '+
						this.form.state.days_after_register+' dias. Desea continuar?'
				swal({
			        title: 'Alerta',
			        text: msg,
			        type: 'warning',
			        showCancelButton: true,
			        confirmButtonColor: '#DD6B55',
			        confirmButtonText: '¡Si, Continuar!',
			        cancelButtonText: '¡No, Cancelar!',
			        closeOnConfirm: true,
			        closeOnCancel: true,
			    },  (isConfirm) => {
			        if (isConfirm) {
			        	this.saving();
			        	return true;
			        }else{
						this.setState({disable_on_save: false});
			        	return false;
			        }
			    });
			 }else{
			 	this.saving();
			 }
			
		}else{
			if(this.props.match.params.donation_id !== 0 && this.props.match.params.donation_id !== '0'){
				//if(this.form.state.can_be_edit){
					this.saving();	
				/*}else{
					this.props.history.goBack();
				}*/
			}else{
				this.saving();
			}
		}
	}

	saveExtraction(obj){
		this.waiting_modal.handleShow('Guardando...');
		fetch(Config.default.apiGateway.URL+'donations/'+obj.id, {
			method: 'PUT', // or 'POST'
			body: JSON.stringify(obj), // data can be `string` or {object}!
			headers: new Headers({
			'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
			'Accept': 'application/json',
			'Content-Type': 'application/json;charset=UTF-8'
			})
		}).then(res => {
			this.waiting_modal.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((result)=>{
					this.setState({disable_on_save: false});
					swal('Error', result, 'error');
				})
			}
		})
		.catch(error => console.error('Error:', error))
		.then(function(response){
			if(response !== undefined){
				if(this.form.state.can_be_edit){
					//this.saveExtractionIncidents(this.form.state);
				}
				this.props.history.goBack();
				
			}
		}.bind(this));
	}

	saving(){
		if (!this.form.validateRequiredFields()) {
			this.setState({disable_on_save: false});
			return;
		}

		if (this.isValidForm()) {
			var obj = this.form.getObj();

			var now = moment().format('HH:mm');
			var beginningTime = moment(now, 'h:mma');
			if(obj.timestamp_hour.indexOf('-') === -1){
				var endTime = moment(obj.timestamp_hour, 'h:mma');
			}

			var now_date = moment().format('YYYY-MM-DD');
			var beginningDate = moment(now_date);
			
			if(obj.timestamp_date !== 'Invalid date'){
				var endDate = moment(obj.timestamp_date)
			}

			if(beginningDate < endDate){
				notify.show('Error, de extracción no puede ser mayor a la hora actual ('+moment(now_date, 'YYYY-MM-DD').format('DD/MM/YYYY')+')','error');
    			document.getElementById('date_extraction_date').classList.add("error");
				document.getElementById('date_extraction_date').style.borderColor = "red";
				this.setState({disable_on_save: false});
			}else if(beginningDate <= endDate && beginningTime.isBefore(endTime)){
				notify.show('Error, La hora de extracción no puede ser mayor a la hora actual ('+now+')', 'error');
				document.getElementById('date_extraction_hour').classList.add("error");
				document.getElementById('date_extraction_hour').style.borderColor = "red";
				this.setState({disable_on_save: false});
			}else if(obj.timestamp_date === 'Invalid date' || obj.timestamp_date === 'Fecha inválida'){
    			notify.show('Error, Fecha invalida','error');
    			document.getElementById('date_extraction_date').classList.add("error");
				document.getElementById('date_extraction_date').style.borderColor = "red";
				this.setState({disable_on_save: false});
    		}else if(obj.timestamp_hour === 'Invalid date' || obj.timestamp_hour === 'Fecha inválida'){
    			notify.show('Error, Hora invalida','error');
    			document.getElementById('date_extraction_hour').classList.add("error");
				document.getElementById('date_extraction_hour').style.borderColor = "red";
				this.setState({disable_on_save: false});
			}else if(obj.apheresis_double ){
				var valid = true;
				this.form.state.unit.map((unit)=>{
					unit.map((u)=>{
						if(u.volume === ""){
							valid = false;
						}
					})
				});
				if(valid){
					this.saveExtraction(obj);
				}else{
					setTimeout(()=>{
						swal({
							title: 'Alerta',
							text: "El campo de volumen está vacío para al menos un componente. Si decide continuar solo se generará una bolsa",
							type: 'warning',
							showCancelButton: true,
							confirmButtonColor: '#DD6B55',
							confirmButtonText: '¡Si, Continuar!',
							cancelButtonText: '¡No, Cancelar!',
							closeOnConfirm: true,
							closeOnCancel: true,
						}, (isConfirm)=> {
							if (isConfirm) {
								this.saveExtraction(obj);
							}else{
								this.setState({disable_on_save: false});
								return;
							}
						});
					}, 500);
				}				
				
			}else{
    			document.getElementById('date_extraction_hour').style.borderColor = "#ccc";
				document.getElementById('date_extraction_hour').classList.remove("error");
				document.getElementById('date_extraction_date').style.borderColor = "#ccc";
				document.getElementById('date_extraction_date').classList.remove("error");
				
				this.saveExtraction(obj)
    			
    		}
	    		
	    } else {
			this.setState({disable_on_save: false});
	    	notify.show('Error, Campos Incompletos','error');
	    }
	}

	saveExtractionIncidents(obj){
		
		var incident_id = '';
		if(obj.method === 'put')
			incident_id = '/'+obj.incident_id;
		else
			incident_id = '';

		var new_obj = {};
		new_obj.manifestation_ids = [];
		new_obj.moment_incident = "moment_during";
		new_obj.incident_ids = obj.incident_ids;
		new_obj.offers_id 	 = obj.offer.item.id;
		var date = moment(obj.timestamp_date, 'DD-MM-YYYY');
		var hour = moment(obj.timestamp_hour, 'h:mm a');
		new_obj.timestamp_date = date.format('MM-DD-YYYY');
		new_obj.timestamp_hour = hour.format('H:mm');
		
		if(new_obj.incident_ids.length > 0){
			fetch(Config.default.apiGateway.URL+'incidents_extraction'+incident_id, {
				method:obj.method,
				body:JSON.stringify(new_obj),
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json;charset=UTF-8'
				})
			})
			.then(res => {
				this.waiting_modal.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then(function(result) {
						this.setState({disable_on_save: false});
						swal('¡Error!', result, 'error');
					});
				}
			})
			.then(response => {
				if(response !== undefined){

					if(this.props.match.params.caller_id !== '0'){
						fetch(Config.default.apiGateway.URL+'caller_actions_history?id='+this.props.match.params.caller_id+'&ip='+sessionStorage.getItem("ip")+'&section=null&option=release ', {
					        method: 'PUT', // or 'PUT'
					        headers: new Headers({
					          'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
					          'Accept': 'application/json',
					          'Content-Type': 'application/json;charset=UTF-8'
					        })
					    }).then(res => {
					        if(res.ok){
					          return res.json();
					        }console.log(res)})
					      .catch(error => console.error('Error:', error))
					      .then(response => {
					        if(response !== undefined){
					        	notify.show('Registro Guardado','success');
					    		this.props.history.goBack();
					        }
					    });
					  }else{
					  	notify.show('Registro Guardado','success');
					    this.props.history.goBack();
					  }
						
				}
			})
		}else{
        	notify.show('Registro Guardado','success');
    		this.props.history.goBack();
		}
	}

	//Verificar si el formulario es valido
	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.form.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });

	    return isFormValid;
	}

	//Contenido de la pantalla para el alta de un nuevo registro
	render(){
		const { t } = this.props;
		var session = sessionStorage.getItem('health_facilities_name');

		return(
			<div className="col-xs-12">
				<div className="route">
		            <h5 className="title_page">
		              {session} ->	
		              {t('sidebar.nav.donors.MAIN')} -> 
		              {t('sidebar.nav.donors.extractions')} -> 
		              {t('content.generics.actions.list')}
		            </h5>
		        </div>
		        <form noValidate>
		        	<FormExtractions {...this.props} onRef={ref => (this.form = ref)} />
		        	<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
		        	<Notifications />
		        </form>
		        <div className="col-xs-12" style={{textAlign:'center'}}>
		        	<div>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} 
		        			disabled={this.state.disable_on_save ? true
								: this.props.match.params.donation_id !== '0' ?
		        				!this.props.task_extraction.update :
		        				!this.props.task_extraction.create} 
						onDoubleClick={(e)=>e.preventDefault()}
		        		onClick={this.saveItem} style={style}/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} onClick={this.cancel} style={style}/>
		        	</div>
		        </div>
		    </div>
		);
	}
}

export default translate('translations')(ExtractionsNew);